import { useMutation, useQueryClient } from 'react-query';

import { createUserPageData as create } from 'api/users/createUserPageData';

const useCreateUserPageData = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: createUserPageData,
    isLoading,
  } = useMutation(create, {
    onSuccess: () => {
      queryClient.invalidateQueries('UsersPageData');
    },
  });

  return {
    isSuccess,
    createUserPageData,
    isLoading,
  };
};

export default useCreateUserPageData;
